// src/modules/helpdesk/meusChamadosMobile.js
// Versão mobile de "Meus Chamados" para os shells (cliente/funcionário/supervisor).
// Overlay full-screen no body (z abaixo do drawer/modal de chamado, que sobem por cima).
// Reaproveita: RPC suporte_chamados_listar, chips de shared.js, drawer _chAbrirDrawer.

import { sb } from '../../api/supabaseClient.js';
import { tenant } from '../../context/tenantContext.js';
import { esc } from '../../lib/dom.js';
import { _chTipoChip, _chPrioChip, _chStatusChip } from './shared.js';
import { _chAbrirDrawer } from './drawerChamado.js';
import { abrirModalChamado } from './novoChamado.js';

const _fmtData = (s) => {
  try { return new Date(s).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' }); }
  catch (_) { return '—'; }
};

export async function openMeusChamadosMobile() {
  document.getElementById('mc-mob-overlay')?.remove();
  const ov = document.createElement('div');
  ov.id = 'mc-mob-overlay';
  ov.style.cssText = 'position:fixed;inset:0;z-index:10010;background:var(--bg,#0E0E14);display:flex;flex-direction:column;overflow:hidden';
  ov.innerHTML = `
    <div style="display:flex;align-items:center;gap:12px;padding:calc(env(safe-area-inset-top,0px) + 14px) 16px 14px;border-bottom:1px solid var(--border);flex-shrink:0">
      <button id="mc-mob-back" aria-label="Voltar" style="background:none;border:none;color:var(--text);padding:4px;cursor:pointer;display:flex"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M15 18l-6-6 6-6"/></svg></button>
      <div style="font-weight:700;font-size:16px;color:var(--text);flex:1">Meus Chamados</div>
      <button id="mc-mob-novo" style="background:var(--accent-bg);border:1px solid var(--sc-info);color:var(--sc-info);border-radius:10px;padding:7px 12px;font-size:12px;font-weight:600;cursor:pointer">+ Novo</button>
    </div>
    <div id="mc-mob-list" style="flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:12px 16px calc(env(safe-area-inset-bottom,0px) + 16px)">
      <div style="text-align:center;color:var(--text3);padding:48px;font-size:13px">Carregando…</div>
    </div>`;
  document.body.appendChild(ov);
  ov.querySelector('#mc-mob-back').addEventListener('click', () => ov.remove());
  ov.querySelector('#mc-mob-novo').addEventListener('click', () => abrirModalChamado());

  const host = ov.querySelector('#mc-mob-list');
  const { data, error } = await sb.rpc('suporte_chamados_listar');
  if (!document.getElementById('mc-mob-overlay')) return; // fechou enquanto carregava
  if (error) {
    host.innerHTML = `<div style="color:var(--red);padding:30px;text-align:center;font-size:13px">Erro ao carregar: ${esc(error.message)}</div>`;
    return;
  }
  let lista = data || [];
  if (!tenant.isAdmin && !tenant.isSuperAdmin) lista = lista.filter((c) => c.usuario_id === tenant.user?.id);
  lista.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  if (!lista.length) {
    host.innerHTML = `<div style="text-align:center;color:var(--text3);padding:56px 16px">
      <div style="font-size:14px;font-weight:600;color:var(--text2);margin-bottom:6px">Nenhum chamado ainda</div>
      <div style="font-size:12px">Toque em “+ Novo” para abrir um chamado de suporte.</div></div>`;
    return;
  }

  host.innerHTML = lista.map((ch) => `
    <div class="mc-mob-card" data-ch="${esc(ch.id)}" style="background:var(--surface,var(--card));border:1px solid var(--border);border-radius:14px;padding:13px 14px;margin-bottom:10px;cursor:pointer">
      <div style="display:flex;justify-content:space-between;gap:10px;align-items:flex-start;margin-bottom:8px">
        <div style="font-weight:600;font-size:13.5px;color:var(--text);line-height:1.3">${esc(ch.assunto || 'Sem assunto')}</div>
        <span style="font:500 11px 'IBM Plex Mono',ui-monospace,monospace;color:var(--text3);white-space:nowrap;flex-shrink:0">${_fmtData(ch.created_at)}</span>
      </div>
      ${(ch.codigo_tela || ch.codigo_modal) ? `<div style="font:500 11px ui-monospace,monospace;color:var(--sc-info);margin-bottom:8px">${esc(ch.codigo_tela || '')}${ch.codigo_modal ? ' → ' + esc(ch.codigo_modal) : ''}</div>` : ''}
      <div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center">${_chTipoChip(ch.tipo)} ${_chPrioChip(ch.prioridade)} ${_chStatusChip(ch.status)}</div>
    </div>`).join('');
  host.querySelectorAll('.mc-mob-card').forEach((el) =>
    el.addEventListener('click', () => _chAbrirDrawer(el.dataset.ch)));
}
